import { render } from "./theFooter.vue?vue&type=template&id=e22638f2&lang=pug&bindings={}"
import script from "./theFooter.vue?vue&type=script&lang=js"
export * from "./theFooter.vue?vue&type=script&lang=js"

import "./theFooter.vue?vue&type=style&index=0&lang=sass"
script.render = render

export default script